/**
 * Do not edit directly
 * Generated on Mon, 29 Jul 2024 07:17:00 GMT
 */

export const BREAKPOINT_XS = 0
export const BREAKPOINT_S = 375
export const BREAKPOINT_M = 768
export const BREAKPOINT_L = 1024
export const BREAKPOINT_XL = 1440
export const BREAKPOINT_XXL = 1920
export const COLOR_BASE_BRAND_WHITE = "#ffffff" // Audi white color
export const COLOR_BASE_BRAND_BLACK = "#000000" // Audi black color
export const COLOR_BASE_BRAND_PROGRESSIVE_RED = "#f50537" // Progressive Red
export const COLOR_BASE_GREY_0 = "#ffffff" // Grey 0
export const COLOR_BASE_GREY_5 = "#f2f2f2" // Grey 5
export const COLOR_BASE_GREY_10 = "#e5e5e5" // Grey 10
export const COLOR_BASE_GREY_15 = "#d9d9d9" // Grey 15
export const COLOR_BASE_GREY_20 = "#cccccc" // Grey 20
export const COLOR_BASE_GREY_30 = "#b3b3b3" // Grey 30
export const COLOR_BASE_GREY_40 = "#999999" // Grey 40
export const COLOR_BASE_GREY_50 = "#808080" // Grey 50
export const COLOR_BASE_GREY_60 = "#666666" // Grey 60
export const COLOR_BASE_GREY_70 = "#4c4c4c" // Grey 70
export const COLOR_BASE_GREY_80 = "#333333" // Grey 80
export const COLOR_BASE_GREY_90 = "#1a1a1a" // Grey 90
export const COLOR_BASE_GREY_100 = "#000000" // Grey 100
export const COLOR_BASE_SIGNAL_RED_LIGHT = "#eb0d3f" // Signal Red
export const COLOR_BASE_SIGNAL_RED_DARK = "#fd2c4e" // Signal Red
export const COLOR_BASE_SIGNAL_GREEN_LIGHT = "#0da20d" // Signal Green
export const COLOR_BASE_SIGNAL_GREEN_DARK = "#0da20d" // Signal Green
export const COLOR_BASE_SIGNAL_YELLOW_LIGHT = "#ffaa00" // Signal Yellow
export const COLOR_BASE_SIGNAL_YELLOW_DARK = "#ffaa00" // Signal Yellow
export const COLOR_BASE_CHARGING_NEON_BLUE_LIGHT = "#2526fe" // Charging Blue
export const COLOR_BASE_CHARGING_NEON_BLUE_DARK = "#556efe" // Charging Blue
export const COLOR_BASE_CHARGING_NEON_GREEN_LIGHT = "#0da20d" // Charging Green
export const COLOR_BASE_CHARGING_NEON_GREEN_DARK = "#15da15" // Charging Green
export const COLOR_CHARGING_DEFAULT_LIGHT = "#0da20d" // charging color; badges, graphs
export const COLOR_CHARGING_DEFAULT_DARK = "#15da15" // charging color; badges, graphs
export const COLOR_CHARGING_INTELLIGENT_LIGHT = "#2526fe" // charging color for intelligent charging; badges, graphs
export const COLOR_CHARGING_INTELLIGENT_DARK = "#556efe" // charging color for intelligent charging; badges, graphs
export const COLOR_BACKGROUND_LEVEL_0_LIGHT = "#ffffff" // first background level
export const COLOR_BACKGROUND_LEVEL_0_DARK = "#000000" // first background level
export const COLOR_BACKGROUND_LEVEL_1_LIGHT = "#ffffff" // second background level
export const COLOR_BACKGROUND_LEVEL_1_DARK = "#1a1a1a" // second background level
export const COLOR_BACKGROUND_LEVEL_2_LIGHT = "#ffffff" // third background level
export const COLOR_BACKGROUND_LEVEL_2_DARK = "#262626" // third background level
export const COLOR_BACKGROUND_LEVEL_3_LIGHT = "#f2f2f2" // forth background level
export const COLOR_BACKGROUND_LEVEL_3_DARK = "#333333" // forth background level
export const COLOR_BACKGROUND_CARD_LIGHT = "#ffffff" // card background
export const COLOR_BACKGROUND_CARD_DARK = "rgba(255, 255, 255, 0.1)" // card background
export const COLOR_BACKGROUND_BACKDROP_STRONG_LIGHT = "rgba(0, 0, 0, 0.9)" // background backdrop
export const COLOR_BACKGROUND_BACKDROP_STRONG_DARK = "rgba(0, 0, 0, 0.7)" // background backdrop
export const COLOR_INTERACTION_PRIMARY_DEFAULT_LIGHT = "#000000" // primary interaction color; default state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_DEFAULT_DARK = "#ffffff" // primary interaction color; default state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_HOVER_LIGHT = "#4c4c4c" // primary interaction color; hover state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_HOVER_DARK = "#b3b3b3" // primary interaction color; hover state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_ACTIVE_LIGHT = "#000000" // primary interaction color; active state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_ACTIVE_DARK = "#ffffff" // primary interaction color; active state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_DISABLED_LIGHT = "#b3b3b3" // primary interaction color; disabled state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_DISABLED_DARK = "#666666" // primary interaction color; disabled state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_FOCUS_LIGHT = "#000000" // primary interaction color; focus state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_FOCUS_DARK = "#ffffff" // primary interaction color; focus state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_PRESSED_LIGHT = "#000000" // primary interaction color; pressed state; texts or icons or shapes
export const COLOR_INTERACTION_PRIMARY_PRESSED_DARK = "#ffffff" // primary interaction color; pressed state; texts or icons or shapes
export const COLOR_INTERACTION_SECONDARY_DEFAULT_LIGHT = "#666666" // secondary interaction color; default state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_DEFAULT_DARK = "#b3b3b3" // secondary interaction color; default state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_HOVER_LIGHT = "#000000" // secondary interaction color; hover state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_HOVER_DARK = "#ffffff" // secondary interaction color; hover state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_ACTIVE_LIGHT = "#000000" // secondary interaction color; active state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_ACTIVE_DARK = "#ffffff" // secondary interaction color; active state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_FILLED_LIGHT = "#333333" // secondary interaction color; filled state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_FILLED_DARK = "#e5e5e5" // secondary interaction color; filled state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_DISABLED_LIGHT = "#b3b3b3" // secondary interaction color; disabled state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_DISABLED_DARK = "#666666" // secondary interaction color; disabled state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_FOCUS_LIGHT = "#000000" // secondary interaction color; focus state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_FOCUS_DARK = "#ffffff" // secondary interaction color; focus state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_READONLY_LIGHT = "#333333" // secondary interaction color; readonly state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_READONLY_DARK = "#e5e5e5" // secondary interaction color; readonly state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_PRESSED_LIGHT = "#000000" // secondary interaction color; pressed state; texts or shapes
export const COLOR_INTERACTION_SECONDARY_PRESSED_DARK = "#ffffff" // secondary interaction color; pressed state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_DEFAULT_LIGHT = "#d9d9d9" // secondary interaction color; default state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_DEFAULT_DARK = "#4c4c4c" // secondary interaction color; default state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_HOVER_LIGHT = "#d9d9d9" // secondary interaction color; hover state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_HOVER_DARK = "#4c4c4c" // secondary interaction color; hover state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_ACTIVE_LIGHT = "#333333" // secondary interaction color; active state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_ACTIVE_DARK = "#e5e5e5" // secondary interaction color; active state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_DISABLED_LIGHT = "#d9d9d9" // secondary interaction color; disabled state; texts or shapes
export const COLOR_INTERACTION_TERTIARY_DISABLED_DARK = "#4c4c4c" // secondary interaction color; disabled state; texts or shapes
export const COLOR_INTERACTION_LABEL_DEFAULT_LIGHT = "#333333" // label interaction color; default state; texts or icons
export const COLOR_INTERACTION_LABEL_DEFAULT_DARK = "#e5e5e5" // label interaction color; default state; texts or icons
export const COLOR_INTERACTION_LABEL_HOVER_LIGHT = "#000000" // label interaction color; hover state; texts or icons
export const COLOR_INTERACTION_LABEL_HOVER_DARK = "#ffffff" // label interaction color; hover state; texts or icons
export const COLOR_INTERACTION_LABEL_ACTIVE_LIGHT = "#333333" // label interaction color; active state; texts or icons
export const COLOR_INTERACTION_LABEL_ACTIVE_DARK = "#e5e5e5" // label interaction color; active state; texts or icons
export const COLOR_INTERACTION_LABEL_FILLED_LIGHT = "#333333" // label interaction color; filled state; texts or icons
export const COLOR_INTERACTION_LABEL_FILLED_DARK = "#e5e5e5" // label interaction color; filled state; texts or icons
export const COLOR_INTERACTION_LABEL_DISABLED_LIGHT = "#b3b3b3" // label interaction color; disabled state; texts or icons
export const COLOR_INTERACTION_LABEL_DISABLED_DARK = "#666666" // label interaction color; disabled state; texts or icons
export const COLOR_INTERACTION_LABEL_FOCUS_LIGHT = "#000000" // label interaction color; focus state; texts or icons
export const COLOR_INTERACTION_LABEL_FOCUS_DARK = "#ffffff" // label interaction color; focus state; texts or icons
export const COLOR_INTERACTION_LABEL_READONLY_LIGHT = "#333333" // label interaction color; readonly state; texts or icons
export const COLOR_INTERACTION_LABEL_READONLY_DARK = "#e5e5e5" // label interaction color; readonly state; texts or icons
export const COLOR_INTERACTION_LABEL_PRESSED_LIGHT = "#000000" // label interaction color; pressed state; texts or icons
export const COLOR_INTERACTION_LABEL_PRESSED_DARK = "#ffffff" // label interaction color; pressed state; texts or icons
export const COLOR_UI_PRIMARY_LIGHT = "#000000" // primary ui color; order 1; audi rings; icons
export const COLOR_UI_PRIMARY_DARK = "#ffffff" // primary ui color; order 1; audi rings; icons
export const COLOR_UI_SECONDARY_LIGHT = "#333333" // secondary ui color; text or icons
export const COLOR_UI_SECONDARY_DARK = "#e5e5e5" // secondary ui color; text or icons
export const COLOR_UI_TERTIARY_LIGHT = "#666666" // tertiary ui color; labels or hints
export const COLOR_UI_TERTIARY_DARK = "#b3b3b3" // tertiary ui color; labels or hints
export const COLOR_UI_INVERTED_LIGHT = "#ffffff" // inverted ui color; text or icons on a dark background
export const COLOR_UI_INVERTED_DARK = "#000000" // inverted ui color; text or icons on a light background
export const COLOR_UI_HIGHLIGHT_PRIMARY_LIGHT = "#eb0d3f" // primary highlight ui color; shapes
export const COLOR_UI_HIGHLIGHT_PRIMARY_DARK = "#fd2c4e" // primary highlight ui color; shapes
export const COLOR_UI_HIGHLIGHT_SECONDARY_LIGHT = "#000000" // secondary highlight ui color; shapes
export const COLOR_UI_HIGHLIGHT_SECONDARY_DARK = "#ffffff" // secondary highlight ui color; shapes
export const COLOR_UI_HIGHLIGHT_TERTIARY_LIGHT = "rgba(0, 0, 0, 0.05)" // tertiary highlight ui color; background
export const COLOR_UI_HIGHLIGHT_TERTIARY_DARK = "rgba(255, 255, 255, 0.15)" // tertiary highlight ui color; background
export const COLOR_UI_DIVIDER_LIGHT = "#d9d9d9" // divider ui color; divider elements on a light background
export const COLOR_UI_DIVIDER_DARK = "#4c4c4c" // divider ui color; divider elements on a dark background 
export const COLOR_UI_ERROR_LIGHT = "#eb0d3f" // error ui color; badges to represent an error state; for accessibility add a change of shape as well
export const COLOR_UI_ERROR_DARK = "#fd2c4e" // error ui color; badges to represent an error state; for accessibility add a change of shape as well
export const COLOR_UI_SUCCESS_LIGHT = "#0da20d" // success ui color; badges to represent a positive state; for accessibility add a change of shape as well
export const COLOR_UI_SUCCESS_DARK = "#0da20d" // success ui color; badges to represent a positive state; for accessibility add a change of shape as well
export const COLOR_UI_PENDING_LIGHT = "#ffaa00" // pending ui color; badges to represent a minor critcal state; for accessibility add a change of shape as well
export const COLOR_UI_PENDING_DARK = "#ffaa00" // pending ui color; badges to represent a minor critcal state; for accessibility add a change of shape as well
export const SHADOW_BACKGROUND_LEVEL_2_LIGHT = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // second shadow level
export const SHADOW_BACKGROUND_LEVEL_2_DARK = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // second shadow level
export const SHADOW_BACKGROUND_LEVEL_3_LIGHT = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // third shadow level
export const SHADOW_BACKGROUND_LEVEL_3_DARK = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // third shadow level
export const SHADOW_BACKGROUND_CARD_LIGHT = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // card shadow
export const SHADOW_BACKGROUND_CARD_DARK = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2))" // card shadow
export const PAGE_MARGIN_XS = 16 // breakpoint xs; ≤ 374px
export const PAGE_MARGIN_S = 28 // breakpoint s; 375-767px
export const PAGE_MARGIN_M = 40 // breakpoint m; 768-1023px
export const PAGE_MARGIN_L = 60 // breakpoint l; 1024-1439px
export const PAGE_MARGIN_XL = 96 // breakpoint xl; 1440-1919px
export const PAGE_MARGIN_XXL = 96 // breakpoint xxl; ≥ 1920px
export const MAX_CONTENT_WIDTH = 1920
export const SPACING_XXS_XS = 4 // breakpoint xs, ≤ 374px; space xss, 4px
export const SPACING_XXS_S = 4 // breakpoint s, 375-767px; space xss, 4px
export const SPACING_XXS_M = 4 // breakpoint m, 768-1023px; space xss, 4px
export const SPACING_XXS_L = 4 // breakpoint l, 1024-1439px; space xss, 4px
export const SPACING_XXS_XL = 4 // breakpoint xl, 1440-1919px; space xss, 4px
export const SPACING_XXS_XXL = 4 // breakpoint xxl, ≥ 1920px; space xss, 4px
export const SPACING_XS_XS = 8 // breakpoint xs, ≤ 374px; space xs, 8px
export const SPACING_XS_S = 8 // breakpoint s, 375-767px; space xs, 8px
export const SPACING_XS_M = 8 // breakpoint m, 768-1023px; space xs, 8px
export const SPACING_XS_L = 8 // breakpoint l, 1024-1439px; space xs, 8px
export const SPACING_XS_XL = 8 // breakpoint xl, 1440-1919px; space xs, 8px
export const SPACING_XS_XXL = 8 // breakpoint xxl, ≥ 1920px; space xs, 8px
export const SPACING_S_XS = 12 // breakpoint xs, ≤ 374px; space s, 12px
export const SPACING_S_S = 12 // breakpoint s, 375-767px; space s, 12px
export const SPACING_S_M = 12 // breakpoint m, 768-1023px; space s, 12px
export const SPACING_S_L = 12 // breakpoint l, 1024-1439px; space s, 12px
export const SPACING_S_XL = 12 // breakpoint xl, 1440-1919px; space s, 12px
export const SPACING_S_XXL = 12 // breakpoint xxl, ≥ 1920px; space s, 12px
export const SPACING_M_XS = 16 // breakpoint xs, ≤ 374px; space m, 16px
export const SPACING_M_S = 16 // breakpoint s, 375-767px; space m, 16px
export const SPACING_M_M = 16 // breakpoint m, 768-1023px; space m, 16px
export const SPACING_M_L = 16 // breakpoint l, 1024-1439px; space m, 16px
export const SPACING_M_XL = 16 // breakpoint xl, 1440-1919px; space m, 16px
export const SPACING_M_XXL = 16 // breakpoint xxl, ≥ 1920px; space m, 16px
export const SPACING_L_XS = 24 // breakpoint xs, ≤ 374px; space l, 24px
export const SPACING_L_S = 24 // breakpoint s, 375-767px; space l, 24px
export const SPACING_L_M = 24 // breakpoint m, 768-1023px; space l, 24px
export const SPACING_L_L = 24 // breakpoint l, 1024-1439px; space l, 24px
export const SPACING_L_XL = 24 // breakpoint xl, 1440-1919px; space l, 24px
export const SPACING_L_XXL = 24 // breakpoint xxl, ≥ 1920px; space l, 24px
export const SPACING_XL_XS = 28 // breakpoint xs, ≤ 374px; space xl, 28px
export const SPACING_XL_S = 28 // breakpoint s, 375-767px; space xl, 28px
export const SPACING_XL_M = 28 // breakpoint m, 768-1023px; space xl, 28px
export const SPACING_XL_L = 28 // breakpoint l, 1024-1439px; space xl, 28px
export const SPACING_XL_XL = 32 // breakpoint xl, 1440-1919px; space xl, 32px
export const SPACING_XL_XXL = 44 // breakpoint xxl, ≥ 1920px; space xl, 44px
export const SPACING_XXL_XS = 36 // breakpoint xs, ≤ 374px; space xxl, 36px
export const SPACING_XXL_S = 36 // breakpoint s, 375-767px; space xxl, 36px
export const SPACING_XXL_M = 36 // breakpoint m, 768-1023px; space xxl, 36px
export const SPACING_XXL_L = 40 // breakpoint l, 1024-1439px; space xxl, 40px
export const SPACING_XXL_XL = 52 // breakpoint xl, 1440-1919px; space xxl, 52px
export const SPACING_XXL_XXL = 68 // breakpoint xxl, ≥ 1920px; space xxl, 68px
export const SPACING_XXXL_XS = 40 // breakpoint xs, ≤ 374px; space xxxl, 40px
export const SPACING_XXXL_S = 40 // breakpoint s, 375-767px; space xxxl, 40px
export const SPACING_XXXL_M = 48 // breakpoint m, 768-1023px; space xxxl, 48px
export const SPACING_XXXL_L = 60 // breakpoint l, 1024-1439px; space xxxl, 60px
export const SPACING_XXXL_XL = 80 // breakpoint xl, 1440-1919px; space xxxl, 80px
export const SPACING_XXXL_XXL = 100 // breakpoint xxl, ≥ 1920px; space xxxl, 100px
export const TYPOGRAPHY_COPY_1_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_COPY_1_FONT_SIZE = 16
export const TYPOGRAPHY_COPY_1_LINE_HEIGHT = 24
export const TYPOGRAPHY_COPY_1_FONT_STRETCH = 105
export const TYPOGRAPHY_COPY_2_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_COPY_2_FONT_SIZE = 12
export const TYPOGRAPHY_COPY_2_LINE_HEIGHT = 20
export const TYPOGRAPHY_COPY_2_FONT_STRETCH = 105
export const TYPOGRAPHY_COPY_3_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_COPY_3_FONT_SIZE = 10
export const TYPOGRAPHY_COPY_3_LINE_HEIGHT = 16
export const TYPOGRAPHY_COPY_3_FONT_STRETCH = 105
export const TYPOGRAPHY_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_FONT_WEIGHTS_NORMAL = 400
export const TYPOGRAPHY_FONT_WEIGHTS_BOLD = 700
export const TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_SIZE = 40
export const TYPOGRAPHY_HEADING_DISPLAY_1_XS_LINE_HEIGHT = 56
export const TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_SIZE = 40
export const TYPOGRAPHY_HEADING_DISPLAY_1_S_LINE_HEIGHT = 56
export const TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_SIZE = 48
export const TYPOGRAPHY_HEADING_DISPLAY_1_M_LINE_HEIGHT = 68
export const TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_SIZE = 60
export const TYPOGRAPHY_HEADING_DISPLAY_1_L_LINE_HEIGHT = 84
export const TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_SIZE = 72
export const TYPOGRAPHY_HEADING_DISPLAY_1_XL_LINE_HEIGHT = 100
export const TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_SIZE = 84
export const TYPOGRAPHY_HEADING_DISPLAY_1_XXL_LINE_HEIGHT = 116
export const TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_SIZE = 36
export const TYPOGRAPHY_HEADING_DISPLAY_2_XS_LINE_HEIGHT = 52
export const TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_SIZE = 36
export const TYPOGRAPHY_HEADING_DISPLAY_2_S_LINE_HEIGHT = 52
export const TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_SIZE = 36
export const TYPOGRAPHY_HEADING_DISPLAY_2_M_LINE_HEIGHT = 52
export const TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_SIZE = 44
export const TYPOGRAPHY_HEADING_DISPLAY_2_L_LINE_HEIGHT = 64
export const TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_SIZE = 52
export const TYPOGRAPHY_HEADING_DISPLAY_2_XL_LINE_HEIGHT = 76
export const TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_SIZE = 60
export const TYPOGRAPHY_HEADING_DISPLAY_2_XXL_LINE_HEIGHT = 84
export const TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_SIZE = 28
export const TYPOGRAPHY_HEADING_ORDER_1_XS_LINE_HEIGHT = 44
export const TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_S_FONT_SIZE = 28
export const TYPOGRAPHY_HEADING_ORDER_1_S_LINE_HEIGHT = 44
export const TYPOGRAPHY_HEADING_ORDER_1_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_M_FONT_SIZE = 28
export const TYPOGRAPHY_HEADING_ORDER_1_M_LINE_HEIGHT = 44
export const TYPOGRAPHY_HEADING_ORDER_1_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_L_FONT_SIZE = 36
export const TYPOGRAPHY_HEADING_ORDER_1_L_LINE_HEIGHT = 52
export const TYPOGRAPHY_HEADING_ORDER_1_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_SIZE = 40
export const TYPOGRAPHY_HEADING_ORDER_1_XL_LINE_HEIGHT = 60
export const TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_SIZE = 44
export const TYPOGRAPHY_HEADING_ORDER_1_XXL_LINE_HEIGHT = 68
export const TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_SIZE = 24
export const TYPOGRAPHY_HEADING_ORDER_2_XS_LINE_HEIGHT = 36
export const TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_S_FONT_SIZE = 24
export const TYPOGRAPHY_HEADING_ORDER_2_S_LINE_HEIGHT = 36
export const TYPOGRAPHY_HEADING_ORDER_2_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_M_FONT_SIZE = 24
export const TYPOGRAPHY_HEADING_ORDER_2_M_LINE_HEIGHT = 36
export const TYPOGRAPHY_HEADING_ORDER_2_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_L_FONT_SIZE = 28
export const TYPOGRAPHY_HEADING_ORDER_2_L_LINE_HEIGHT = 44
export const TYPOGRAPHY_HEADING_ORDER_2_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_SIZE = 32
export const TYPOGRAPHY_HEADING_ORDER_2_XL_LINE_HEIGHT = 48
export const TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_SIZE = 36
export const TYPOGRAPHY_HEADING_ORDER_2_XXL_LINE_HEIGHT = 52
export const TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_SIZE = 20
export const TYPOGRAPHY_HEADING_ORDER_3_XS_LINE_HEIGHT = 32
export const TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_S_FONT_SIZE = 20
export const TYPOGRAPHY_HEADING_ORDER_3_S_LINE_HEIGHT = 32
export const TYPOGRAPHY_HEADING_ORDER_3_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_M_FONT_SIZE = 20
export const TYPOGRAPHY_HEADING_ORDER_3_M_LINE_HEIGHT = 32
export const TYPOGRAPHY_HEADING_ORDER_3_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_L_FONT_SIZE = 20
export const TYPOGRAPHY_HEADING_ORDER_3_L_LINE_HEIGHT = 32
export const TYPOGRAPHY_HEADING_ORDER_3_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_SIZE = 24
export const TYPOGRAPHY_HEADING_ORDER_3_XL_LINE_HEIGHT = 36
export const TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_SIZE = 24
export const TYPOGRAPHY_HEADING_ORDER_3_XXL_LINE_HEIGHT = 36
export const TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_SIZE = 16
export const TYPOGRAPHY_HEADING_ORDER_4_XS_LINE_HEIGHT = 24
export const TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_S_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_S_FONT_SIZE = 16
export const TYPOGRAPHY_HEADING_ORDER_4_S_LINE_HEIGHT = 24
export const TYPOGRAPHY_HEADING_ORDER_4_S_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_M_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_M_FONT_SIZE = 16
export const TYPOGRAPHY_HEADING_ORDER_4_M_LINE_HEIGHT = 24
export const TYPOGRAPHY_HEADING_ORDER_4_M_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_L_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_L_FONT_SIZE = 16
export const TYPOGRAPHY_HEADING_ORDER_4_L_LINE_HEIGHT = 24
export const TYPOGRAPHY_HEADING_ORDER_4_L_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_SIZE = 18
export const TYPOGRAPHY_HEADING_ORDER_4_XL_LINE_HEIGHT = 28
export const TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_STRETCH = 130
export const TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_FAMILY = "AudiType, sans-serif"
export const TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_SIZE = 20
export const TYPOGRAPHY_HEADING_ORDER_4_XXL_LINE_HEIGHT = 32
export const TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_STRETCH = 130

export default {
  BREAKPOINT_XS,
  BREAKPOINT_S,
  BREAKPOINT_M,
  BREAKPOINT_L,
  BREAKPOINT_XL,
  BREAKPOINT_XXL,
  COLOR_BASE_BRAND_WHITE,
  COLOR_BASE_BRAND_BLACK,
  COLOR_BASE_BRAND_PROGRESSIVE_RED,
  COLOR_BASE_GREY_0,
  COLOR_BASE_GREY_5,
  COLOR_BASE_GREY_10,
  COLOR_BASE_GREY_15,
  COLOR_BASE_GREY_20,
  COLOR_BASE_GREY_30,
  COLOR_BASE_GREY_40,
  COLOR_BASE_GREY_50,
  COLOR_BASE_GREY_60,
  COLOR_BASE_GREY_70,
  COLOR_BASE_GREY_80,
  COLOR_BASE_GREY_90,
  COLOR_BASE_GREY_100,
  COLOR_BASE_SIGNAL_RED_LIGHT,
  COLOR_BASE_SIGNAL_RED_DARK,
  COLOR_BASE_SIGNAL_GREEN_LIGHT,
  COLOR_BASE_SIGNAL_GREEN_DARK,
  COLOR_BASE_SIGNAL_YELLOW_LIGHT,
  COLOR_BASE_SIGNAL_YELLOW_DARK,
  COLOR_BASE_CHARGING_NEON_BLUE_LIGHT,
  COLOR_BASE_CHARGING_NEON_BLUE_DARK,
  COLOR_BASE_CHARGING_NEON_GREEN_LIGHT,
  COLOR_BASE_CHARGING_NEON_GREEN_DARK,
  COLOR_CHARGING_DEFAULT_LIGHT,
  COLOR_CHARGING_DEFAULT_DARK,
  COLOR_CHARGING_INTELLIGENT_LIGHT,
  COLOR_CHARGING_INTELLIGENT_DARK,
  COLOR_BACKGROUND_LEVEL_0_LIGHT,
  COLOR_BACKGROUND_LEVEL_0_DARK,
  COLOR_BACKGROUND_LEVEL_1_LIGHT,
  COLOR_BACKGROUND_LEVEL_1_DARK,
  COLOR_BACKGROUND_LEVEL_2_LIGHT,
  COLOR_BACKGROUND_LEVEL_2_DARK,
  COLOR_BACKGROUND_LEVEL_3_LIGHT,
  COLOR_BACKGROUND_LEVEL_3_DARK,
  COLOR_BACKGROUND_CARD_LIGHT,
  COLOR_BACKGROUND_CARD_DARK,
  COLOR_BACKGROUND_BACKDROP_STRONG_LIGHT,
  COLOR_BACKGROUND_BACKDROP_STRONG_DARK,
  COLOR_INTERACTION_PRIMARY_DEFAULT_LIGHT,
  COLOR_INTERACTION_PRIMARY_DEFAULT_DARK,
  COLOR_INTERACTION_PRIMARY_HOVER_LIGHT,
  COLOR_INTERACTION_PRIMARY_HOVER_DARK,
  COLOR_INTERACTION_PRIMARY_ACTIVE_LIGHT,
  COLOR_INTERACTION_PRIMARY_ACTIVE_DARK,
  COLOR_INTERACTION_PRIMARY_DISABLED_LIGHT,
  COLOR_INTERACTION_PRIMARY_DISABLED_DARK,
  COLOR_INTERACTION_PRIMARY_FOCUS_LIGHT,
  COLOR_INTERACTION_PRIMARY_FOCUS_DARK,
  COLOR_INTERACTION_PRIMARY_PRESSED_LIGHT,
  COLOR_INTERACTION_PRIMARY_PRESSED_DARK,
  COLOR_INTERACTION_SECONDARY_DEFAULT_LIGHT,
  COLOR_INTERACTION_SECONDARY_DEFAULT_DARK,
  COLOR_INTERACTION_SECONDARY_HOVER_LIGHT,
  COLOR_INTERACTION_SECONDARY_HOVER_DARK,
  COLOR_INTERACTION_SECONDARY_ACTIVE_LIGHT,
  COLOR_INTERACTION_SECONDARY_ACTIVE_DARK,
  COLOR_INTERACTION_SECONDARY_FILLED_LIGHT,
  COLOR_INTERACTION_SECONDARY_FILLED_DARK,
  COLOR_INTERACTION_SECONDARY_DISABLED_LIGHT,
  COLOR_INTERACTION_SECONDARY_DISABLED_DARK,
  COLOR_INTERACTION_SECONDARY_FOCUS_LIGHT,
  COLOR_INTERACTION_SECONDARY_FOCUS_DARK,
  COLOR_INTERACTION_SECONDARY_READONLY_LIGHT,
  COLOR_INTERACTION_SECONDARY_READONLY_DARK,
  COLOR_INTERACTION_SECONDARY_PRESSED_LIGHT,
  COLOR_INTERACTION_SECONDARY_PRESSED_DARK,
  COLOR_INTERACTION_TERTIARY_DEFAULT_LIGHT,
  COLOR_INTERACTION_TERTIARY_DEFAULT_DARK,
  COLOR_INTERACTION_TERTIARY_HOVER_LIGHT,
  COLOR_INTERACTION_TERTIARY_HOVER_DARK,
  COLOR_INTERACTION_TERTIARY_ACTIVE_LIGHT,
  COLOR_INTERACTION_TERTIARY_ACTIVE_DARK,
  COLOR_INTERACTION_TERTIARY_DISABLED_LIGHT,
  COLOR_INTERACTION_TERTIARY_DISABLED_DARK,
  COLOR_INTERACTION_LABEL_DEFAULT_LIGHT,
  COLOR_INTERACTION_LABEL_DEFAULT_DARK,
  COLOR_INTERACTION_LABEL_HOVER_LIGHT,
  COLOR_INTERACTION_LABEL_HOVER_DARK,
  COLOR_INTERACTION_LABEL_ACTIVE_LIGHT,
  COLOR_INTERACTION_LABEL_ACTIVE_DARK,
  COLOR_INTERACTION_LABEL_FILLED_LIGHT,
  COLOR_INTERACTION_LABEL_FILLED_DARK,
  COLOR_INTERACTION_LABEL_DISABLED_LIGHT,
  COLOR_INTERACTION_LABEL_DISABLED_DARK,
  COLOR_INTERACTION_LABEL_FOCUS_LIGHT,
  COLOR_INTERACTION_LABEL_FOCUS_DARK,
  COLOR_INTERACTION_LABEL_READONLY_LIGHT,
  COLOR_INTERACTION_LABEL_READONLY_DARK,
  COLOR_INTERACTION_LABEL_PRESSED_LIGHT,
  COLOR_INTERACTION_LABEL_PRESSED_DARK,
  COLOR_UI_PRIMARY_LIGHT,
  COLOR_UI_PRIMARY_DARK,
  COLOR_UI_SECONDARY_LIGHT,
  COLOR_UI_SECONDARY_DARK,
  COLOR_UI_TERTIARY_LIGHT,
  COLOR_UI_TERTIARY_DARK,
  COLOR_UI_INVERTED_LIGHT,
  COLOR_UI_INVERTED_DARK,
  COLOR_UI_HIGHLIGHT_PRIMARY_LIGHT,
  COLOR_UI_HIGHLIGHT_PRIMARY_DARK,
  COLOR_UI_HIGHLIGHT_SECONDARY_LIGHT,
  COLOR_UI_HIGHLIGHT_SECONDARY_DARK,
  COLOR_UI_HIGHLIGHT_TERTIARY_LIGHT,
  COLOR_UI_HIGHLIGHT_TERTIARY_DARK,
  COLOR_UI_DIVIDER_LIGHT,
  COLOR_UI_DIVIDER_DARK,
  COLOR_UI_ERROR_LIGHT,
  COLOR_UI_ERROR_DARK,
  COLOR_UI_SUCCESS_LIGHT,
  COLOR_UI_SUCCESS_DARK,
  COLOR_UI_PENDING_LIGHT,
  COLOR_UI_PENDING_DARK,
  SHADOW_BACKGROUND_LEVEL_2_LIGHT,
  SHADOW_BACKGROUND_LEVEL_2_DARK,
  SHADOW_BACKGROUND_LEVEL_3_LIGHT,
  SHADOW_BACKGROUND_LEVEL_3_DARK,
  SHADOW_BACKGROUND_CARD_LIGHT,
  SHADOW_BACKGROUND_CARD_DARK,
  PAGE_MARGIN_XS,
  PAGE_MARGIN_S,
  PAGE_MARGIN_M,
  PAGE_MARGIN_L,
  PAGE_MARGIN_XL,
  PAGE_MARGIN_XXL,
  MAX_CONTENT_WIDTH,
  SPACING_XXS_XS,
  SPACING_XXS_S,
  SPACING_XXS_M,
  SPACING_XXS_L,
  SPACING_XXS_XL,
  SPACING_XXS_XXL,
  SPACING_XS_XS,
  SPACING_XS_S,
  SPACING_XS_M,
  SPACING_XS_L,
  SPACING_XS_XL,
  SPACING_XS_XXL,
  SPACING_S_XS,
  SPACING_S_S,
  SPACING_S_M,
  SPACING_S_L,
  SPACING_S_XL,
  SPACING_S_XXL,
  SPACING_M_XS,
  SPACING_M_S,
  SPACING_M_M,
  SPACING_M_L,
  SPACING_M_XL,
  SPACING_M_XXL,
  SPACING_L_XS,
  SPACING_L_S,
  SPACING_L_M,
  SPACING_L_L,
  SPACING_L_XL,
  SPACING_L_XXL,
  SPACING_XL_XS,
  SPACING_XL_S,
  SPACING_XL_M,
  SPACING_XL_L,
  SPACING_XL_XL,
  SPACING_XL_XXL,
  SPACING_XXL_XS,
  SPACING_XXL_S,
  SPACING_XXL_M,
  SPACING_XXL_L,
  SPACING_XXL_XL,
  SPACING_XXL_XXL,
  SPACING_XXXL_XS,
  SPACING_XXXL_S,
  SPACING_XXXL_M,
  SPACING_XXXL_L,
  SPACING_XXXL_XL,
  SPACING_XXXL_XXL,
  TYPOGRAPHY_COPY_1_FONT_FAMILY,
  TYPOGRAPHY_COPY_1_FONT_SIZE,
  TYPOGRAPHY_COPY_1_LINE_HEIGHT,
  TYPOGRAPHY_COPY_1_FONT_STRETCH,
  TYPOGRAPHY_COPY_2_FONT_FAMILY,
  TYPOGRAPHY_COPY_2_FONT_SIZE,
  TYPOGRAPHY_COPY_2_LINE_HEIGHT,
  TYPOGRAPHY_COPY_2_FONT_STRETCH,
  TYPOGRAPHY_COPY_3_FONT_FAMILY,
  TYPOGRAPHY_COPY_3_FONT_SIZE,
  TYPOGRAPHY_COPY_3_LINE_HEIGHT,
  TYPOGRAPHY_COPY_3_FONT_STRETCH,
  TYPOGRAPHY_FONT_FAMILY,
  TYPOGRAPHY_FONT_WEIGHTS_NORMAL,
  TYPOGRAPHY_FONT_WEIGHTS_BOLD,
  TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_1_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_1_XXL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_DISPLAY_2_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_DISPLAY_2_XXL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_1_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_1_XXL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_2_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_2_XXL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_3_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_3_XXL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_XS_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_XS_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_S_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_S_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_S_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_S_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_M_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_M_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_M_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_M_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_L_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_L_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_L_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_L_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_XL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_XL_FONT_STRETCH,
  TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_FAMILY,
  TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_SIZE,
  TYPOGRAPHY_HEADING_ORDER_4_XXL_LINE_HEIGHT,
  TYPOGRAPHY_HEADING_ORDER_4_XXL_FONT_STRETCH,
}